import BaseStore from './base-store'
import {get_file} from 'stores/files'
import {API_PROFILE} from 'consts/api'
import {API2_USERS} from 'consts/api2'

class ProfileStore extends BaseStore {
  constructor() {
    super({
      id: undefined,
      name: '',
      email: '',
      is_admin: false,
      is_superuser: false,
      is_beta: false,
      is_tenant_manager: false,
      tenant_id: undefined,

      // old profile
      web_notification: true,
      mail_notification: true,
      web_notification_id: undefined,
      occupied_storage: 0,
      storage_limit: 0,

      // new profile
      first_name: undefined,
      last_name: undefined,
      title: undefined,
      company_name: undefined,
      company_site: undefined,
      shared_company_id: undefined,
      avatar_id: undefined,
      avatar_ur: undefined,
      bio: undefined,
      offering: undefined,
      tone_type: undefined,
      instructions: undefined,
      memory: [],
      pulse_digest_enabled: true,
    })
  }

  get display_name() {
    if (this.first_name || this.last_name) {
      return `${this._state.first_name || ''} ${this._state.last_name || ''}`.trim()
    }
    return this.name
  }

  get chat_type() {
    return 'chat_v2'
  }

  async doLoad(rest, params) {
    const data = await rest.get(API_PROFILE, params)

    // Do we need this check?
    for (const prop in data) {
      if (data[prop] === null || data[prop] === undefined) {
        delete data[prop]
      }
    }
    Object.assign(this._state, data)

    if (this._state.avatar_id) {
      const avatar_data = await get_file(this._state.avatar_id)
      this._state.avatar_url = avatar_data.url
    }
  }

  async doSave(rest, changed) {
    const to_write = {}

    for (const key of changed) to_write[key] = this._state[key]
    const {bleach} = await rest.patch(API_PROFILE, to_write)
    this._bleach(bleach)
  }

  async fetchUsers(filter) {
    return await this._rest.get(API2_USERS)
  }

  async updateUser(id, what) {
    await this._rest.patch(`${API2_USERS}/${id}`, what)
  }
}

const profile = new ProfileStore()
export default profile
